module.exports = __webpack_public_path__ + "static/mopz-footerBanner@2x-min-4569994e1c2cd425987287505d56bd58.png";